<template>
    <div class="mainContainer">
        <Banner/>
        <div class="listContainer w11 mtop40">
            <!-- 少儿国学 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-1.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">少儿国学</p>
                </learn-sort>
                <learn-list routeSort="classRoom">
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-1.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
            <!-- 少儿英语 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-2.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">少儿英语</p>
                </learn-sort>
                <learn-list>
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-2.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
            <!-- 音乐学院 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-3.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">音乐学院</p>
                </learn-sort>
                <learn-list>
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-3.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
            <!-- 舞蹈学院 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-4.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">舞蹈学院</p>
                </learn-sort>
                <learn-list>
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-4.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
            <!-- 科技与健康讲座 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-5.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">科技与健康讲座</p>
                </learn-sort>
                <learn-list>
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-5.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
            <!-- 国学讲座 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-6.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">国学讲座</p>
                </learn-sort>
                <learn-list>
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-6.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
            <!-- 摄影学院 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-7.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">摄影学院</p>
                </learn-sort>
                <learn-list>
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-7.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
        </div>
    </div>
</template>

<script>
import Banner from "views/PcViews/Learn/Classroom/Index/Banner"
import LearnModule from "components/contents/learnModule/LearnModule"
import LearnList from "components/contents/learnList/LearnList"
import LearnSort from "components/common/learnSort/LearnSort"
import LearnItem from "components/common/learnItem/LearnItem"
export default {
    components:{ Banner, LearnModule, LearnList, LearnSort, LearnItem },
    data(){
        return {

        }
    }
}
</script>

<style lang="less" scoped>
.listContainer{
    overflow: hidden;
}
</style>
